import { ContractVariableSourceEnum } from '@clickersphere/core/enums/ContractVariableSourceEnum';

export const variableSourceLabelKeys = {
  [ContractVariableSourceEnum.LEAD]: 'contract.variableSource.LEAD',
  [ContractVariableSourceEnum.LEAD_LEGAL]: 'contract.variableSource.LEAD_LEGAL',
  [ContractVariableSourceEnum.CONTRACTOR]: 'contract.variableSource.CONTRACTOR',
  [ContractVariableSourceEnum.SERVICE]: 'contract.variableSource.SERVICE',
  [ContractVariableSourceEnum.PAYMENT]: 'contract.variableSource.PAYMENT',
  [ContractVariableSourceEnum.ISSUANCE]: 'contract.variableSource.ISSUANCE',
  [ContractVariableSourceEnum.CUSTOM]: 'contract.variableSource.CUSTOM',
} as const;

export const missingVariableHintKeys = {
  [ContractVariableSourceEnum.LEAD]: 'contract.issue.missingHint.LEAD',
  [ContractVariableSourceEnum.LEAD_LEGAL]:
    'contract.issue.missingHint.LEAD_LEGAL',
  [ContractVariableSourceEnum.CONTRACTOR]:
    'contract.issue.missingHint.CONTRACTOR',
  [ContractVariableSourceEnum.SERVICE]: 'contract.issue.missingHint.SERVICE',
  [ContractVariableSourceEnum.PAYMENT]: 'contract.issue.missingHint.PAYMENT',
  [ContractVariableSourceEnum.ISSUANCE]: 'contract.issue.missingHint.ISSUANCE',
  [ContractVariableSourceEnum.CUSTOM]: 'contract.issue.missingHint.CUSTOM',
} as const;
